/*global jQuery*/
/**
 * {{name}}
 * Global JS
 *
 * version: {{version}}
 * file:    {{file}}
 * author:  Squiz Australia
 * change log:
 *     {{date}} - First revision
 */

/*
 * Table of Contents
 *
 * - Global
 * - Modules
{{toc}}
 */
'use strict';
/*
--------------------
Global
--------------------
*/
//  Declare JS Enabled.
$('body').removeClass('no-js').addClass('js-enabled');


/*
--------------------
Modules
--------------------
*/


// Search auto complete functions and initialisation

$(document).ready(function(){
    
    var $search = $('.js-search');

    if($search.length){
        $search.each(function () {
            activateSearch($(this));
        });
    } 

    var currentHash = window.location.hash;
    if(currentHash.length > 0) {
        linkHashHandler(currentHash);
    } 

    $('a').not('.accordion a').click(function(){
        if($(this).hasClass('js-set-hidden')) {
            return;
        }
        var href  = $(this).attr('href');
        if(href.indexOf('#') < 0) {
            return;
        }else if(href.indexOf('#') == 0 && href.length == 1){
            return;
        }
        linkHashHandler(href);
    });
});

function escapeRegExp(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

function activateSearch($search) {
    var searchPartialBaseUrl = $search.attr('data-partial-url'),
        searchPartialResults = $search.attr('data-partial-results'),
        collection = $search.attr('data-partial-collection'),
        $searchInput = $search.find('.js-search-input'),
        searchInputName = $searchInput.attr('name'),
        $searchPredictiveList = $search.find('.js-search-list'),
        searchInputValue = '';

    $search.focusout(function(){
        setTimeout(function(){
            var $focused = $search.find(':focus');

            if (!$focused.length) {
                $searchPredictiveList.fadeOut(300);
            }
        }, 100); //delay to wait until other element recieved focus
    });

    $searchInput.focusin(function(){
        $searchPredictiveList.fadeIn(300);
    }).keydown(function(e){

        if(e.keyCode === 40) {//keydown
            if($searchPredictiveList.find('a').length) {
                $searchPredictiveList.find('li:first-child a').focus();
            }
        }
    }).keyup(debounce(function () {
        //for fb autocomplte, need to use partial_query as parameter
        var searchValue = $searchInput.val(),
            searchQuery = searchValue.toLowerCase(),
            searchPartialUrl = searchPartialBaseUrl
                + '?&fmt=json++&partial_query=' + encodeURIComponent(searchValue)
                + '&show=' + searchPartialResults + '&collection=' + collection;

        if(searchInputValue !== searchValue) {
            searchInputValue = $.parseJSON(JSON.stringify(searchValue)); //cloning to break the reference

            if(searchQuery.length > 2) {
                $.getJSON(searchPartialUrl, function (data) {
                    $searchPredictiveList.empty();

                    data = $.parseJSON(JSON.stringify(data));

                    if(data.length > 0) {
                        var searchQueryRegex = new RegExp('(' + escapeRegExp(searchQuery) + ')', 'gi'),
                        $searchPredictiveListHtml = '<ul>\n';

                        $.each(data, function (key, item) {
                            var searchPredictiveItem = item.disp,
                                searchPredictiveItemHtml = searchPredictiveItem.replace(
                                    searchQueryRegex,
                                    '<span>$1</span>'
                                );
                            $searchPredictiveListHtml += '<li><a href="#">' + searchPredictiveItemHtml + '</a></li>\n';
                        });

                        $searchPredictiveListHtml += '</ul>\n';

                        $searchPredictiveList.html($searchPredictiveListHtml);
                    } 

                    $searchPredictiveList.find('a').focusin(function () {
                        $searchInput.val($(this).text());
                    }).keydown(function (e) {
                        if (e.keyCode === 40) { //arrow down
                            var $next = $(this).parent('li').next();

                            if ($next.length) {
                                $next.find('a').focus();
                                e.preventDefault();
                            }
                        } else if (e.keyCode === 38) { //arrow up
                            var $prev = $(this).parent('li').prev();

                            if ($prev.length) {
                                $prev.find('a').focus();
                                e.preventDefault();
                            }
                        }
                    }).click(function (e) {
                        e.preventDefault();
                        $searchInput.val($(this).text());
                        $searchInput.closest('form').submit();
                        return false;
                    });
                });                   
            } else {
                $searchPredictiveList.empty();
            }
        }
    }, 250));
}

function linkHashHandler(hashedId) {

    
    if(hashedId.indexOf('#') === 0) {
      var $hashedIdItem = $(hashedId);

      if($hashedIdItem.length === 1) {

          if ($hashedIdItem.closest('.accordion').find('.accordion__target').length) {
              
              var $accordionTitle = $hashedIdItem.closest('.js-accordion-title');
            if($accordionTitle) {
                if(!$accordionTitle.hasClass('active')) {
                    var $accordionToggle = $accordionTitle.children('a');
                    $accordionToggle.trigger('click');  
                }
            }
        }
 
        $('html, body').animate({
          scrollTop: $hashedIdItem.offset().top - 10
        }, 1000);
      }
    } else {
      return false;
    }
  }

